<template>
  <div
    class="tab-pane"
    v-if="loaded || active"
    v-show="active"
    role="tabpanel"
    :aria-hidden="!active"
    :id="`pane-${paneName}`"
    :aria-labelledby="`tab-${paneName}`"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TabPane',
  componentName: 'TabPane',
  props: {
    // 名称用于定位
    name: {
      type: String,
      default: '',
    },
    // tab 导航文字
    label: {
      type: String,
      default: '',
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    // 标签是否客可关闭
    closable: {
      type: Boolean,
      default: false,
    },
    index: {
      type: [Number, String],
      default: '',
    },
    superscript: {
      type: [Number, String],
      default: '',
    },
    superscriptBgColor: {
      type: String,
      default: '',
    },
    superscriptColor: {
      type: String,
      default: '#fff',
    },
    superscriptSize: {
      type: [Number, String],
      default: '20',
    },
  },
  data() {
    return {
      loaded: false,
    }
  },
  watch: {
    // superscript() {
    //   this.$parent.calcPaneInstances()
    // },
    // label() {
    //   this.$parent.calcPaneInstances()
    // }
  },
  updated() {
    this.$parent.calcPaneInstances()
  },
  computed: {
    isClosable() {
      return this.closable || this.$parent.closable
    },
    active() {
      const active = this.$parent.modelValue === (this.name || this.index)
      if (active) {
        this.loaded = true
      }
      return active
    },
    paneName() {
      return this.name
    },
  },
}
</script>
